import { Link } from "react-router-dom";

const footerSections = [
  {
    title: "热门分类",
    links: [
      { label: "恋爱漫画", to: "/category/romance" },
      { label: "奇幻漫画", to: "/category/fantasy" },
      { label: "动作漫画", to: "/category/action" },
      { label: "悬疑漫画", to: "/category/thriller" },
      { label: "搞笑漫画", to: "/category/comedy" },
      { label: "古风漫画", to: "/category/historical" },
    ],
  },
  {
    title: "快速链接",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "全部漫画", to: "/category/all" },
      { label: "最新更新", to: "/category/all?sort=latest" },
      { label: "热门排行", to: "/category/all?sort=popular" },
      { label: "用户协议", to: "#" },
      { label: "隐私政策", to: "#" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
          <div className="md:col-span-5">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-bold font-heading">韩漫画网</span>
            </Link>
            <p className="text-foreground-400 text-sm leading-relaxed mb-6 max-w-sm">
              韩漫画网提供高清免费韩国漫画大全和最新热门漫画在线阅读，涵盖恋爱、奇幻、动作、悬疑等多种题材，内容精彩画质清晰，每日更新。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors cursor-pointer" aria-label="QQ">
                <i className="ri-qq-line text-lg"></i>
              </a>
            </div>
          </div>

          {footerSections.map((section) => (
            <div key={section.title} className="md:col-span-3">
              <h4 className="text-sm font-semibold mb-4 text-background-50">{section.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-foreground-400 hover:text-primary-400 text-sm transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-1"></div>
        </div>

        <div className="border-t border-foreground-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} 韩漫画网 HanManHua.com 版权所有
          </p>
          <div className="flex items-center gap-4 text-foreground-500 text-xs">
            <a href="#" className="hover:text-primary-400 transition-colors">用户协议</a>
            <a href="#" className="hover:text-primary-400 transition-colors">隐私政策</a>
            <a href="#" className="hover:text-primary-400 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}